module.exports = "/assets/7845956341553cc09ce17dafb587af58.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/B0.png
// module id = 2343
// module chunks = 0